import { pipeAddMuscles } from "./index33.js";
import { pipeTailor } from "./index70.js";
import { pipeAddPlots } from "./index80.js";
import { pipeClearZone } from "./index175.js";
import { GetAllJoints, GetAllMuscles, RG_TYPE, getRgObjectsOfType, roundDecimals } from "@project-rouge/rg-core";
import { MuscleToVector } from "@project-rouge/rg-three";
import { Vector3 } from "three";
var batch = {
	size: 10,
	pickCount: 1
};
const pipeFilter = ([parent, { aggProps, buildingIds, cache, briefIndex }]) => {
	return [parent, updateProps(aggProps, findBestItem({
		parent,
		aggProps,
		buildingIds,
		cache,
		briefIndex
	}).aggSeed)];
};
function findBestItem({ parent, aggProps, buildingIds, cache, briefIndex }) {
	const requiredCacheSize = Math.ceil((1 + briefIndex) / batch.pickCount) * batch.size;
	for (let x = cache.length; x < requiredCacheSize; x++) {
		aggProps = updateProps(aggProps, x);
		pipeClearZone([parent, { aggProps }]);
		pipeAddPlots([parent, { aggProps }]);
		pipeTailor([parent, { aggProps }]);
		pipeAddMuscles([parent, {
			aggProps,
			buildingIds
		}]);
		const hash = getHash(parent);
		const score = scoreDO(parent, hash, cache);
		cache.push({
			score,
			aggSeed: x,
			hash
		});
		if (cache.length % batch.size === 0) {
			cache.sort((a, b) => b.score - a.score);
			const picks = cache.filter((c) => c.briefIndex === void 0).slice(0, batch.pickCount);
			const startBriefIndex = (cache.length / batch.size - 1) * batch.pickCount;
			picks.forEach((c, i) => {
				c.briefIndex = startBriefIndex + i;
			});
		}
	}
	return cache.find((c) => c.briefIndex === briefIndex);
}
function getHash(obj) {
	const hash = getRgObjectsOfType(obj, RG_TYPE.Building).map((b) => GetAllJoints(b.data.anatomy)).flat().flatMap((j) => j.pos);
	for (let i = 0; i < hash.length; i++) hash[i] = roundDecimals(hash[i]);
	hash.sort((a, b) => a - b);
	return hash;
}
function updateProps(aggProps, i) {
	const zonesKeys = Object.keys(aggProps.zones);
	const zonesProps = Object.entries(aggProps.zones);
	aggProps = {
		...aggProps,
		zones: {}
	};
	for (const [key, zoneProps] of zonesProps) aggProps.zones[key] = {
		...zoneProps,
		skeletonTailorSeed: zoneProps.skeletonTailorSeed === void 0 ? void 0 : i,
		subdivisionSeed: i + zonesKeys.indexOf(key)
	};
	return aggProps;
}
var mVector = new Vector3();
function scoreDO(obj, hash, cache) {
	for (const item of cache) {
		if (item.hash.length !== hash.length) continue;
		if (item.hash.some((v, i) => v !== hash[i])) continue;
		return -Infinity;
	}
	const buildings = getRgObjectsOfType(obj, RG_TYPE.Building);
	let totalLength = 0;
	for (const b of buildings) {
		const muscles = GetAllMuscles(b.data.anatomy);
		totalLength += muscles.reduce((sum$1, m) => sum$1 + MuscleToVector(m, mVector).length(), 0);
	}
	return totalLength;
}
export { pipeFilter };

//# sourceMappingURL=index176.js.map